module.exports = __webpack_public_path__ + "static/media/right.8e6807c3.png";